/**
 *  @class
 *  @function CollectionTabs
 */
if (typeof CollectionTabs === 'undefined') {
	class CollectionTabs {
		constructor() {
			const _this = this;
			let collection_tabs = document.querySelectorAll(
				'.collection-tabs__list'
			);

			if (!collection_tabs) {
				return;
			}
			collection_tabs.forEach((tabs) => {
				if (tabs.dataset.initiated) {
					return;
				}
				const buttons = tabs.querySelectorAll('button'),
					target = tabs.dataset.target;

				tabs.dataset.initiated = true;

				buttons.forEach((button) => {
					button.addEventListener('click', (event) => {
						let handle = button.dataset.collection;
						[].forEach.call(buttons, function (el) {
							el.classList.remove('active');
						});
						button.classList.add('active');

						if (handle) {
							_this.toggleCollection(target, handle);
						}

						event.preventDefault();
					});
				});

				const bindArrows = () => {
					const slider = document.getElementById(target);

					if (!slider) return false;

					const flkty = Flickity.data(slider);

					if (!flkty) return false;

					this.updateArrowState(slider, flkty);

					return true;
				};

				if (!bindArrows()) {
					setTimeout(bindArrows, 100);
				}

				window.addEventListener('resize', () => bindArrows());
			});
		}

		toggleCollection(target, handle) {
			let slider = document.getElementById(target),
				products = slider.querySelectorAll(
					`.columns:not([data-collection*="${handle}"])`
				),
				active_products = slider.querySelectorAll(
					`[data-collection*="${handle}"]:not(.is-hidden)`
				),
				flkty = Flickity.data(slider);

			[].forEach.call(products, function (el) {
				el.classList.remove('carousel__slide');
				slider.append(el);
			});
			[].forEach.call(active_products, function (el) {
				el.classList.add('carousel__slide');
			});
			flkty.insert(active_products);
			flkty.reloadCells();
			flkty.reposition();
			flkty.select(0, false, true);

			if (typeof syncCarouselSlideFocus === 'function') {
				syncCarouselSlideFocus(flkty);
			}

			this.updateArrowState(slider, flkty);
			requestAnimationFrame(() => this.updateArrowState(slider, flkty));
		}

		updateArrowState(slider, flkty) {
			const prevButton = slider.querySelector('.flickity-prev');
			const nextButton = slider.querySelector('.flickity-next');

			if (!prevButton || !nextButton || !flkty) return;

			const updateButtons = () => {
				slider.classList.remove('carousel--loading');

				if (!slider.classList.contains('carousel--show-arrows')) {
					prevButton.classList.add('is-disabled');
					nextButton.classList.add('is-disabled');

					return;
				}

				const viewport = slider.querySelector('.flickity-viewport') || slider;
				const cells = (flkty.getCellElements() || []).filter(
					(cell) => !cell.classList.contains('is-hidden')
				);
				const lastCell = cells[cells.length - 1];
				const firstCell = cells[0];

				if (!lastCell || !firstCell) {
					prevButton.classList.add('is-disabled');
					nextButton.classList.add('is-disabled');

					return;
				}

				const viewportRect = viewport.getBoundingClientRect();
				const lastRect = lastCell.getBoundingClientRect();
				const firstRect = firstCell.getBoundingClientRect();
				const overflowRight = lastRect.right - viewportRect.right > 20;
				const overflowLeft = viewportRect.left - firstRect.left > 20;

				prevButton.classList.toggle('is-disabled', !overflowLeft);
				nextButton.classList.toggle('is-disabled', !overflowRight);
			};

			updateButtons();

			if (flkty._collectionTabsArrowsBound) return;

			flkty._collectionTabsArrowsBound = true;
			flkty.on('change', updateButtons);
			flkty.on('settle', updateButtons);
			flkty.on('ready', updateButtons);
		}
	}

	window.addEventListener('load', () => {
		new CollectionTabs();
	});
}
